import { Link } from "react-router-dom";
import { ArrowRight, Mic2 } from "lucide-react";
import { useT } from "@/context/I18nContext";

export default function ApplyTeaser() {
  const { t } = useT();
  const italic = t("apply.italic");
  const title = t("apply.title").split("{italic}");
  return (
    <section
      className="border-y av-hairline bg-[#141210]/60"
      data-testid="apply-teaser"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-[auto_1fr_auto] items-center gap-6">
        <div className="w-16 h-16 rounded-full bg-[#E5A93C]/15 border border-[#E5A93C]/40 flex items-center justify-center">
          <Mic2 size={26} className="text-[#E5A93C]" />
        </div>
        <div>
          <span className="av-eyebrow">{t("apply.eyebrow")}</span>
          <h2 className="font-serif-display text-3xl sm:text-4xl mt-2">
            {title[0]}
            <span className="italic text-[#E5A93C]">{italic}</span>
            {title[1]}
          </h2>
          <p className="text-[#F7F4EE]/75 mt-2 max-w-xl text-sm">{t("apply.subtitle")}</p>
        </div>
        <Link to="/candidati" className="av-pill av-pill-gold" data-testid="apply-teaser-cta">
          {t("apply.cta")} <ArrowRight size={14} />
        </Link>
      </div>
    </section>
  );
}
